var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"x-small":"","color":"danger","outlined":""},on:{"click":function($event){return _vm.deleteAbsence()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-trash-can")]),_vm._v("löschen")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }